import { defineComponent as _defineComponent } from 'vue';
import Swiper, { Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import { gsap } from "gsap";
import { Observer } from "gsap/Observer";
import { useHead } from "@unhead/vue";
import LangSelect from "@/components/basic/langselect/index.vue";
import BgmAudio from "@/components/basic/audio/audio.vue";
import PcButton from "@/components/basic/pc-button.vue";
import { track } from '@/lib/utils';
import IconBgmActive from "@/resources/images/btn-bgm-active.png";
import IconBgm from "@/resources/images/btn-bgm.png";
import Bgm from "@/resources/audio/bgm.mp3";
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    Swiper.use([Pagination]);
    const {
      getI18nWord,
      parseI18nJson,
      lang
    } = useCommon();
    const {
      rem
    } = storeToRefs(useFlexStore());
    const {
      initFlexiable
    } = useFlexStore();
    const BANNER_CNT = 5;
    const bannerSwiper = ref();
    const rewardsRef = ref();
    const swiperIndex = computed(() => bannerSwiper.value ? bannerSwiper.value.realIndex : -1);
    const eventRewards = computed(() => {
      if (swiperIndex.value < 0) return [];
      const data = parseI18nJson(`event-rewards-${swiperIndex.value + 1}`);
      return data !== null && data !== void 0 ? data : [];
    });
    const mediaData = computed(() => {
      if (swiperIndex.value < 0) return [];
      const data = parseI18nJson("media-list");
      return data !== null && data !== void 0 ? data : [];
    });
    useHead({
      title: getI18nWord("web-title")
    });
    initFlexiable();
    onMounted(async () => {
      track({
        category: 'page',
        action: 'view'
      });
      await nextTick();
      bannerSwiper.value = new Swiper(".swiper", {
        width: 6.73 * rem.value,
        watchOverflow: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          // 必须匹配模板中的分页器类名
          type: "bullets"
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          resize: function () {
            if (!bannerSwiper.value) return;
            bannerSwiper.value.params.width = 6.73 * rem.value;
            bannerSwiper.value.update();
          }
        }
      });
      Observer.create({
        target: ".reward-list",
        type: "touch,pointer",
        lockAxis: true,
        dragMinimum: 50,
        onLeft: () => rewardsScrollX("right"),
        onRight: () => rewardsScrollX("left")
      });
      gsap.to(".black-mask", {
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: ".ghost",
          start: "bottom bottom",
          end: "bottom top",
          scroller: "#app > .content",
          scrub: true
        }
      });
    });
    function rewardsScrollX(direct, dist = 20) {
      if (!rewardsRef.value) return;
      const offset = dist / 100 * rem.value;
      gsap.to(rewardsRef.value, {
        scrollTo: {
          x: rewardsRef.value.scrollLeft + (direct === "right" ? 1 : -1) * offset,
          autoKill: true
        },
        ease: "power3.out",
        duration: 0.2
      });
    }
    function swiperToPrev() {
      if (!bannerSwiper.value) return;
      track({
        category: 'button',
        action: 'click',
        label: 'LeftArrow'
      });
      bannerSwiper.value.slidePrev();
    }
    function swiperToNext() {
      if (!bannerSwiper.value) return;
      track({
        category: 'button',
        action: 'click',
        label: 'RightArrow'
      });
      bannerSwiper.value.slideNext();
    }
    function clickJoinNow() {
      track({
        category: 'button',
        action: 'click',
        label: 'JoinNow'
      });
      openUrl(getI18nWord('join-now-url'));
    }
    function clickJoinEvent() {
      track({
        category: 'button',
        action: 'click',
        label: 'JoinEvent',
        value: swiperIndex.value + 1
      });
      openUrl(getI18nWord(`event-url-${swiperIndex.value + 1}`));
    }
    function clickDownload() {
      track({
        category: 'button',
        action: 'click',
        label: 'Download'
      });
      openUrl(getI18nWord('model-download-url'));
    }
    function clickOpenMedia(media) {
      track({
        category: 'button',
        action: 'click',
        label: {
          facebook: 'Fb',
          discord: 'Discord',
          x: 'X',
          ytb: 'Youtube',
          ins: lang !== 'ko-kr' ? 'Ins' : getI18nWord('ins-name')
        }[media]
      });
      openUrl(getI18nWord(`${media}-url`));
    }
    function clickOpenOfficialSite() {
      track({
        category: 'button',
        action: 'click',
        label: 'OfficialSite'
      });
      openUrl(getI18nWord('official-site-url'));
    }
    function openUrl(url) {
      var _window$open;
      if (!window) return;
      (_window$open = window.open(url, "_blank")) === null || _window$open === void 0 || _window$open.focus();
    }
    return {
      __sfc: true,
      getI18nWord,
      parseI18nJson,
      lang,
      rem,
      initFlexiable,
      BANNER_CNT,
      bannerSwiper,
      rewardsRef,
      swiperIndex,
      eventRewards,
      mediaData,
      rewardsScrollX,
      swiperToPrev,
      swiperToNext,
      clickJoinNow,
      clickJoinEvent,
      clickDownload,
      clickOpenMedia,
      clickOpenOfficialSite,
      openUrl,
      LangSelect,
      BgmAudio,
      PcButton,
      IconBgmActive,
      IconBgm,
      Bgm
    };
  }
});